import { combineReducers } from 'redux';

import settings, { AppSettingsState } from './settings';

export const STATE_ROOT = 'apps';

export interface AppDetailsState {
  settings: AppSettingsState
}

export default combineReducers({
  settings,
});
